module.exports = __webpack_public_path__ + "img/t5-11.01295f32.jpg";